import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from "@angular/core";
import { DriverStatus, IDriver } from "@interfaces/IDriver";
import { DriverService } from "@services/driver.service";
import "./driver-list.component.scss";

@Component({
    selector: "driver-list-new",
    template: require("./driver-list.component.html")
})
export class DriverListComponent implements OnInit, OnChanges {

    @Input() selectedDriver: IDriver;
    @Output() driverClick = new EventEmitter<IDriver>();

    @ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport;

    // ---

    drivers: IDriver[];
    displayDrivers: IDriver[] = [];
    loading = false;
    rowHeight = 51;

    constructor(private readonly driverService: DriverService) { }

    ngOnInit() {
        this.loadData();
    }

    ngOnChanges() {
        this.scrollToSelectedDriver();
    }

    onSearch(text: string) {
        if (!text) {
            this.displayDrivers = this.drivers;
            return;
        }

        this.displayDrivers = this.driverService.searchDrivers(this.drivers, text);
    }

    trackByDriver(index: number, driver: IDriver) {
        return driver.Id;
    }

    clickRow(driver: IDriver) {
        this.driverClick.emit(driver);
    }

    // ---

    private loadData() {
        this.loading = true;

        this.driverService.getDrivers()
            .then(drivers => {
                this.sortDrivers(drivers);

                this.drivers = drivers;
                this.displayDrivers = drivers;
            })
            .finally(() => {
                this.loading = false;
                window.dispatchEvent(new Event('resize'));

                this.scrollToSelectedDriver();
                console.log(this.displayDrivers);
            });
    }

    private scrollToSelectedDriver() {
        if (!this.selectedDriver|| !this.drivers) {
            return;
        }

        setTimeout(() => {
            var index = this.displayDrivers.findIndex(v => v.Id == this.selectedDriver.Id);

            // Ensure viewport is rendered well
            this.virtualScroll.scrollToIndex(index);
        });
    }

    private sortDrivers(drivers: IDriver[]) {
        // Need default sorter?
        drivers.sort((d1, d2) => {
            // Show active drivers first
            if (d1.Status == DriverStatus.Active && d2.Status == DriverStatus.Inactive) {
                return -1;
            }
            else if (d1.Status == DriverStatus.Inactive && d2.Status == DriverStatus.Active) {
                return 1;
            }

            return d1.DisplayName.localeCompare(d2.DisplayName);
        });
    }
}
